import { EditorViewPersonalisationsAction } from "./EditorViewPersonalisationsAction";
export default EditorViewPersonalisationsAction;
export * from "./EditorViewPersonalisationsAction";
